import { FocusEvent } from 'react';

export const NAV_BENEFITS = 'benefits';
export const NAV_LESSONS = 'lessons';
export const NAV_YEARS = 'years';
export const NAV_SUPPORT = 'support';
export const NAV_CONTACT_US = 'contact-us';
export const NAV_PRICING = 'pricing';
export const NAV_PRODUCT = 'product';
export const NAV_EXPLORE = 'explore';

export const NAV_BENEFITS_LABEL = 'Benefits';
export const NAV_LESSONS_LABEL = 'Lessons';
export const NAV_DISCIPLINES_LABEL = 'Discipline';
export const NAV_STIMULUS_LIBRARY_LABEL = 'Stimulus Library';
export const NAV_SCOPE_AND_SEQUENCE_LABEL = 'Scope and Sequence';
export const NAV_SUPPORT_LABEL = 'Support';
export const NAV_FOR_TEACHERS_LABEL = 'For Teachers';
export const NAV_FOR_SCHOOLS_LABEL = 'For Schools';
export const NAV_PRODUCT_LABEL = 'Product';
export const NAV_PRICING_LABEL = 'Pricing';
export const NAV_ABOUT_LABEL = 'About Us';
export const NAV_TERMS_AND_PRIVACY_LABEL = 'Terms and Privacy';
export const NAV_TEACHING_BLOG_LABEL = 'The Teaching Blog';
export const NAV_FAQS_LABEL = 'FAQs';
export const NAV_CONTACT_US_LABEL = 'Contact Us';
export const NAV_SEND_MESSAGE_LABEL = 'Send us a Message';
export const NAV_EXPLORE_INQUISITIVE_LABEL = 'Explore Inquisitive';

export type Props = {
  activeId: string;
  handleOnFocus: (e: FocusEvent) => void;
  handleOnClick: (id: string) => void;
};

type MegaNavSection = {
  element: HTMLElement;
  links: HTMLElement[];
  position: number;
};
export type MegaNavMenu = MegaNavSection[];
